/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalManager from './hospital-manager';
import HospitalManagerDetail from './hospital-manager-detail';
import HospitalManagerUpdate from './hospital-manager-update';
import HospitalManagerDeleteDialog from './hospital-manager-delete-dialog';

const HospitalManagerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalManager />} />
    <Route path="new" element={<HospitalManagerUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalManagerDetail />} />
      <Route path="edit" element={<HospitalManagerUpdate />} />
      <Route path="delete" element={<HospitalManagerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalManagerRoutes;
